import React, { Component } from 'react';

//All of our API calls
import * as Actions from '../actions/action';

//Stores all of our API responses
import Store from '../stores/store';

//These are all our styles (font-awesome + our global css)
import '../styles/fonts/FontAwesome6/css/all.css';
import '../styles/global.css';

class FileDelete extends Component {
    constructor(props) {
        super(props);
        Actions.getActionGroupFileList();
        this.state = {
            file: null,
            title: "",
            name: "",
            desc: "",
            allFiles: [],
        };

    }

    componentDidMount() {
        Store.on("Response_File_ListInfo_Updated", this._updateFileList.bind(this));
        Store.on("Response_File_Uploaded", this._filesChanged.bind(this));
        Store.on("Response_File_Deleted", this._filesChanged.bind(this));  
    }

    componentWillUnmount() {
    }

    _filesChanged = () => {
        this.setState({ file: null, title: "", desc: "" });
        Actions.getActionGroupFileList();
    }

    _updateFileList = () => {
        this.setState({ allFiles: Store.getActionGroupFileList() });
        this.setState({ file: null, title: "", desc: "" });
    }

    _handleFileChange() {
        let item = this.state.allFiles.find(i => i.fileId === this.refs["fileSearch"].value);
        if (!item) {
            this.setState({ file: null, title: "", name: "", desc: "" });
        }
        else {
            this.setState({ file: item, title: item.fileName, name: item.fileOriginalName, desc: item.fileDesc });
        }
    }

    _deleteFile = () => {
        Actions.removeActionGroupFile(this.state.file.fileId);
    }

    render() {
        var fileSelect = [];
        var fileInfo = [];
        var deleteButton = [];

        if (this.state.file != null) {
            fileInfo.push(

                <div className="fileUpload_Label_Container">
                    <div className="fileUpload_LabelHeader"><i className="employeeList_icon fal fa-circle-info"></i> File Info</div>
                    <div>
                        <table className="fileUpload_FileTable">
                            <tbody>
                                <tr>
                                    <td>
                                        File
                                    </td>
                                    <td className="download_fileDetails">
                                        {this.state.name}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Title
                                    </td>
                                    <td className="download_fileDetails">
                                        {this.state.title}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Description
                                    </td>
                                    <td className="download_fileDetails">
                                        {this.state.desc}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );
            deleteButton.push(
                <div className="accessGroup_fileDownload">
                    <button className="singleResultButton_Create singleButton accessGroups_Upload" onClick={this._deleteFile.bind(this)}>
                        <table>
                            <tbody>
                                <tr>
                                    <td><span className="singleResultIcon fal fa-file-xmark"></span></td>
                                    <td><span className="footerText"><div className="topText">Delete</div><div className="bottomText">File</div></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </button>
                </div>
            );
        }

        fileSelect.push(
            <div>
                <div className="fileUpload_Label_Container">
                    <div className="fileUpload_LabelHeader"><i className="employeeList_icon fal fa-file-xmark"></i> File Delete</div>
                    <select className="fileDownload_Selectbox" ref="fileSearch" value={this.state.fileSelection} onChange={this._handleFileChange.bind(this)}>
                        <option key='' value=''>Please select a file.</option>
                        {this.state.allFiles.map(r => <option key={r.fileId} value={r.fileId}> {r.fileName} {((r.fileOriginalName).length > 0) ? "(" + r.fileOriginalName + ")" : ""} </option>)}
                    </select>
                </div>
                {fileInfo}
                {deleteButton}
            </div>
        );
        return (
            <div>
                {fileSelect}
            </div>)
    }
}

export default FileDelete